import styled from 'styled-components'
import { SCREEN } from '../../styles/screens'

export const Plan = styled.div`
  height: 106px;
  cursor: pointer;
  padding: 16px;
  border-radius: 6px;
  border: ${p =>
    p.selected ? '2px solid var(--secondary)' : '2px solid var(--primary)'};
  background-color: ${p => (p.selected ? 'var(--secondary)' : 'transparent')};
  display: flex;
  align-items: center;
  margin-bottom: calc(var(--spacing) * 4);
  justify-content: space-between;
  transition: all 0.2s ease-in-out;
  h6 {
    margin: 0;
    font-weight: normal;
    flex: 0 0 44%;
    font-size: 26px;
    @media only screen and (max-width: ${SCREEN.MOBILE}) {
      font-size: 22px;
    }
  }
  small {
    font-size: 14px;
    margin: 0;
    @media only screen and (max-width: ${SCREEN.MOBILE}) {
    }
  }
`
